import { Tab } from '@mui/material';
import { StyledTabs } from './FilterTab.style';

type TProps<T> = {
  tabs: string[];
  currentTab: T;
  setCurrentTab: (tab: T) => void;
  onTabChange?: (tab: T) => void;
};

export const FilterTab = <T extends string>({
  tabs,
  currentTab,
  setCurrentTab,
  onTabChange,
}: TProps<T>) => (
  <StyledTabs
    value={currentTab}
    onChange={(_e, value) => {
      const tab = value as T;
      setCurrentTab(tab);
      onTabChange?.(tab);
    }}
  >
    {Object.entries(tabs).map(([key, value]) => (
      <Tab
        value={value}
        label={value}
        key={key}
        sx={{
          position: 'relative',
          // 主題 button typography 的 capitalize 會把 macOS 渲染成 MacOS，
          // 頁籤文字需照字面顯示
          textTransform: 'none',
          '&::after': {
            backgroundColor: currentTab === value ? '#837300' : 'transparent',
            borderRadius: '2px',
            bottom: 0,
            content: '""',
            height: '3px',
            left: 0,
            position: 'absolute',
            width: '100%',
          },
        }}
      />
    ))}
  </StyledTabs>
);
